export const CONFIG = window.config;
export const TRANSLATIONS = window.translations;
export const INTERNAL_TRANSLATIONS = window.internal_translations;
export const DEVSTRING = 'development';

export const LOGIN_STATUS = {
    internal: 'internalLogIn',
    external: 'externalLogIn',
};

export const LOGIN_USER_ACCESS = {
    external: 'External User',
    internal: 'Internal User'
};
export const PAGE_ROOT_URLS = {
    internal: '/internal',
    external: '/external',
};

export const NODE_ENVIRONMENTS = {
    dev: 'development',
    prod: 'production',
};

export const DASHBOARD_MENU = {
    Personal: 1,
    MyDirectReport: 2,
};

export const DASHBOARD_TAB = {
    MobileWireless: "0",
    FixedLineWireLine: "1",
};

export const REQUEST_MODAL_TAB = {
    RequestProgress: "0",
    Comments: "1",
};

export const APIHEADERS = {
    "content-type": "application/json",
    "access-token": "",
    "Authorization": "",
    "X-CSRF-TOKEN": "",
    "RequestVerificationToken": "",

    'Cache-Control': 'no-store',
    'Pragma': 'no-cache',
    'Expires': '-1',
    'TimezoneOffset': new Date().getTimezoneOffset(),
};

export const APIHEADERSTOKENONLY = {
    "access-token": "",
    "Authorization": "",
    "X-CSRF-TOKEN": "",
    "RequestVerificationToken": ""
}

export const METHODS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    POST_FILE: 'POST_FILE',
    DOWNLOAD: 'DOWNLOAD'
};

export const USER_ROLES_ID = {
    admin: 1,
    analyst: 2,
    reporting: 3,
    client: 4,
    manager: 5,
    lineManager: 6,
};

export const CIRCUIT_CATEGORIES = {
    mobile: 1,
    fixed: 2,
    hoc: 3,
};

export const CIRCUIT_TYPES = {
    mobile_or_cellphone: 1,
    mpls: 10,
    internet: 9,
    ptp: 12
}

export const CIRCUIT_STATUS_PERSONAL = {
    InService: 1,
    OutOfService: 2,
    Suspended: 3,
    Pending: 4
}

export const SUB_CIRCUIT_TYPES = {
    ptp: 23,
    access: 19,
    port: 20,
    mpls: 39
}

export const QUOTATION_BANDWIDTH = {
    other: 18
}

export const CHARGE_TYPE_CATEGORIES = {
    Voice: {
        spendDetailsColor: '#008eff',
        usageDetailsColor: '#008eff',
        usageUom: 'mins.',
        type: 'Voice',
    },
    Messaging: {
        spendDetailsColor: '#be82ff',
        usageDetailsColor: '#be82ff',
        usageUom: '',
        type: 'Messaging',
    },
    Data: {
        spendDetailsColor: '#f580c0',
        usageDetailsColor: '#f580c0',
        usageUom: 'MB',
        type: 'Data',
    },
    Other: {
        spendDetailsColor: '#f49342',
        usageDetailsColor: '#f49342',
        usageUom: '',
        type: 'Other',
    },
    Total: {
        spendDetailsColor: '#ffffff',
        usageDetailsColor: '#ffffff',
        type: 'Total',
    },
};

export const USAGE_SPEND_CHART = {
    LineChart: 1,
    BarChart: 2,
};

export const EXHIBIT_TYPE = {
    exhibitA: 1,
    exhibitB: 2,
    exhibitC: 3,
    exhibitD: 4,
};


export const MODAL_TYPES = {
    requestForms: 1,
    requestDetails: 2,
    inventoryModal: 3
};

export const REQUEST_TYPES_ID = {
    newCircuitOrder: 1,
    manageExisting: 2,
    newOrder: 3,
    changeUser: 4,
    changePricePlan: 5,
    simReplacement: 6,
    subscriptionCancellation: 7,
    newMobile: 9,
    terminate: 10,
    portOut: 11,
    portIn: 12,
    deviceReplacement: 33,
    //changeInvoiceAddress: 13,
    changeVendor: 14,
    otherRequestOther: 15,
    newHomeOfficeConnection: 16,

    //Wireline Request
    updatePlanWireline: 24,
    terminateSubscriptionWireline: 25,
    otherWireline: 26,
    newSubscriptionWireline: 27,
    newQuotation: 28,
    wirelineChangeVendor: 29,
    //wireline other request
    wirelineUpgradeCircuit: 30,
    wirelineChangeLocationAddress: 31,
    wirelineOtherOther: 32,

    //other request types
    simActivation: 17,
    roamingActivation: 18,
    pukCode: 19,
    itemizedBillingofCallsReport: 20,
    changeInvoiceAddress: 21,
    moveHOC: 22,
    other: 23,

    //other request types type2
    InternationalPlanRequest: 34,
    Accessory: 35,
    EnableHotspot: 36,
    ChangeNumber: 37,
    SuspendResumeService: 38,
    InternationalRoamingAccess: 40,
    InternationalAccessRequest: 39,
    CallingAccess: 41,
    otherSIMReplacement: 42,
    otherChangeOfPlan: 43,

    // new mobile request types
    simAndDevice: 44,
    newMobileDevice: 45,
    wifiDongleAndDataCard: 46,
    simAndDeviceBSA: 47,
    simOnlyBSA: 48,
    multiSIMBSA: 49,
    wifiDongleAndDataCardBIN: 50,
    voiceSIMBIN: 51,
    wifiDongleDataCardAndVoiceSIMBIN: 52
};

export const DISABLED_FIELDS_PER_REQUEST_TYPE = {
    default: [
        'statusID', 'currency', 'primarySecondary', 'financeAccountTypeName', 'clientName', 'vendor',
        'endUserID', 'userName', 'emailAddress', 'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate'
    ],
    changeUser: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'monthlyRateCharge', 'currency',
        'primarySecondary', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID', 'userName',
        'emailAddress', 'lineManager', 'TypeId', 'ModelId', 'IMEISerialNumber', 'AssetTagNumber', 'StatusId',
        'ProductName', 'AdditionalInformation', 'PartCode', 'Price', 'linkedCircuitID', 'equipmentActionBtn', 'deleteEquipment', 
        'installDate', 'disconnectDate', 'suspensionDate'
    ],
    newMobile: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress',
        'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment', 'StatusId', 'endUserID',
    ],
    simAndDevice: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress',
        'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment', 'StatusId', 'endUserID',
    ],
    newMobileDevice: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress',
        'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment', 'StatusId', 'endUserID',
    ],
    wifiDongleAndDataCard: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress',
        'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment', 'StatusId', 'endUserID',
    ],
    simAndDeviceBSA: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress',
        'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment', 'StatusId', 'endUserID',
    ],
    simOnlyBSA: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress',
        'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment', 'StatusId', 'endUserID',
    ],
    multiSIMBSA: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress',
        'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment', 'StatusId', 'endUserID',
    ],
    wifiDongleAndDataCardBIN: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress',
        'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment', 'StatusId', 'endUserID',
    ],
    voiceSIMBIN: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress',
        'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment', 'StatusId', 'endUserID',
    ],
    wifiDongleDataCardAndVoiceSIMBIN: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress',
        'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment', 'StatusId', 'endUserID',
    ],
    subscriptionCancellation: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'monthlyRateCharge', 'currency',
        'primarySecondary', 'billingAccountID', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'locationID', 'AddPlanDetails', 'TypeID', 'Rank', 'SerialNumber',
        'PINNumber', 'ProductName', 'SIM', 'PUK1', 'PUK2', 'AdditionalInformation', 'ModelId', 'IMEISerialNumber',
        'AssetTagNumber', 'StatusId', 'TypeId', 'SIMProductName', 'PartCode', 'Price', 'linkedCircuitID', 'GLCode',
        'CostCenter', 'percent', 'demarcLocation', 'SIMAdditionalInformation', 'AddSimDetails', 'installDate', 'disconnectDate',
        'suspensionDate','StatusId', 'deleteEquipment'
    ],
    portIn: [
        'statusID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor',
        'endUserID', 'userName', 'emailAddress', 'lineManager', 'AddPlanDetails', 'status', 'installDate', 'disconnectDate', 'suspensionDate','StatusId'
    ],
    portOut: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'monthlyRateCharge', 'currency',
        'primarySecondary', 'billingAccountID', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'locationID', 'AddPlanDetails', 'TypeID', 'Rank', 'SerialNumber',
        'PINNumber', 'SIMProductName', 'SIM', 'PUK1', 'PUK2', 'AdditionalInformation', 'SIMAdditionalInformation',
        'ModelId', 'IMEISerialNumber', 'AssetTagNumber', 'StatusId', 'TypeId', 'ProductName', 'PartCode', 'Price',
        'linkedCircuitID', 'GLCode', 'CostCenter', 'percent', 'demarcLocation', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment'
    ],
    deviceReplacement: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'monthlyRateCharge', 'currency',
        'primarySecondary', 'linkedCircuitID', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'installDate', 'disconnectDate', 'suspensionDate', 'TypeId',
         'ModelId', 'StatusId', 'AddSimDetails', 'installDate', 'disconnectDate', 'suspensionDate', 'status', 'deleteEquipment'
    ],
    InternationalRoamingAccess: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'monthlyRateCharge', 'currency',
        'primarySecondary', 'billingAccountID', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'locationID', 'AddPlanDetails', 'TypeID', 'Rank', 'SerialNumber',
        'PINNumber', 'SIMProductName', 'SIM', 'PUK1', 'PUK2', 'AdditionalInformation', 'SIMAdditionalInformation',
        'ModelId', 'IMEISerialNumber', 'AssetTagNumber', 'StatusId', 'TypeId', 'ProductName', 'PartCode', 'Price',
        'linkedCircuitID', 'GLCode', 'CostCenter', 'percent', 'demarcLocation', 'installDate', 'disconnectDate', 'suspensionDate'
    ],
    CallingAccess: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'monthlyRateCharge', 'currency',
        'primarySecondary', 'billingAccountID', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'locationID', 'AddPlanDetails', 'TypeID', 'Rank', 'SerialNumber',
        'PINNumber', 'SIMProductName', 'SIM', 'PUK1', 'PUK2', 'AdditionalInformation', 'SIMAdditionalInformation',
        'ModelId', 'IMEISerialNumber', 'AssetTagNumber', 'StatusId', 'TypeId', 'ProductName', 'PartCode', 'Price',
        'linkedCircuitID', 'GLCode', 'CostCenter', 'percent', 'demarcLocation', 'installDate', 'disconnectDate', 'suspensionDate','deleteEquipment'

    ],
    RoamingAccess: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'monthlyRateCharge', 'currency',
        'primarySecondary', 'billingAccountID', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'locationID', 'AddPlanDetails', 'TypeID', 'Rank', 'SerialNumber',
        'PINNumber', 'SIMProductName', 'SIM', 'PUK1', 'PUK2', 'AdditionalInformation', 'SIMAdditionalInformation',
        'ModelId', 'IMEISerialNumber', 'AssetTagNumber', 'StatusId', 'TypeId', 'ProductName', 'PartCode', 'Price',
        'linkedCircuitID', 'GLCode', 'CostCenter', 'percent', 'demarcLocation', 'installDate', 'disconnectDate', 'suspensionDate'

    ],
    Accessory: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'monthlyRateCharge', 'currency',
        'primarySecondary', 'linkedCircuitID', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'installDate', 'disconnectDate', 'suspensionDate', 'TypeId',
        'ModelId', 'StatusId', 'AddSimDetails', 'installDate', 'disconnectDate', 'suspensionDate'
    ],
    changeVendor: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'monthlyRateCharge', 'currency',
        'primarySecondary', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID', 'userName',
        'emailAddress', 'lineManager', 'linkedCircuitID', 'installDate', 'disconnectDate', 'suspensionDate', 'deleteEquipment'
    ],
    other: [
        'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress', 'lineManager'
    ],
    ChangeNumber: [
        'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress', 'lineManager'
    ],
    simActivation: [
        'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress', 'lineManager'
    ],
    EnableHotspot: [
        'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress', 'lineManager'
    ],
    pukCode: [
        'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress', 'lineManager'
    ],
    otherSIMReplacement: [
        'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress', 'lineManager'
    ],
    otherChangeOfPlan: [
        'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress', 'lineManager'
    ],
    SuspendResumeService: [
        'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'userName', 'emailAddress', 'lineManager'
    ],

    terminateSubscriptionWireline: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'monthlyRateCharge', 'currency',
        'primarySecondary', 'billingAccountID', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'locationID', 'AddPlanDetails', 'TypeID', 'Rank', 'SerialNumber',
        'PINNumber', 'SIMProductName', 'SIM', 'PUK1', 'PUK2', 'AdditionalInformation', 'SIMAdditionalInformation',
        'ModelId', 'IMEISerialNumber', 'AssetTagNumber', 'StatusId', 'TypeId', 'ProductName', 'PartCode', 'Price',
        'linkedCircuitID', 'GLCode', 'CostCenter', 'percent', 'demarcLocation', 'installDate', 'disconnectDate', 'suspensionDate', 'siteSurveyRequested',
        'accessBandwidth', 'access', 'existingCircuitID', 'existingCircuitID', 'isCoordinatedService', 'electricalOpticalInterface', 'requiredLOACFA', 'accessPortCIR',
        'DLCI', 'serviceClass', 'uploadSpeed', 'downloadSpeed', 'requestedIP', 'handsOffType', 'electricalOpticalInterface', 'portSpeed',
        'carrierQOSProfile', 'asnNumber', 'voiceCAR', 'routingProtocol', 'vpnName', 'voiceCARSpeed', 'asnNewOrExisting', 'siteOfOrigin', 'deleteEquipment'
    ],

    wirelineChangeVendor:[
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'currency', 'billingAccountID', 'billingAccountID', 'financeAccountTypeName', 'clientName',
        'vendor', 'endUserID', 'userName', 'emailAddress', 'lineManager', 'installDate', 'disconnectDate', 'suspensionDate'
    ],

    newSubscriptionWireline: [
        'statusID', 'circuitTypeID', 'subCircuitTypeID', 'currency', 
        'primarySecondary', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'installDate', 'disconnectDate', 'suspensionDate'
    ],
  
    wirelineOtherOther: [
        'circuitTypeID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'installDate', 'disconnectDate', 'suspensionDate'
    ],
    wirelineUpgradeCircuit: [
        'circuitTypeID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'installDate', 'disconnectDate', 'suspensionDate'
    ],
    wirelineChangeLocationAddress: [
        'circuitTypeID', 'currency', 'financeAccountTypeName', 'clientName', 'vendor', 'endUserID',
        'userName', 'emailAddress', 'lineManager', 'installDate', 'disconnectDate', 'suspensionDate'
    ],
    updatePlanWireline: [
        'circuitCode', 'statusID', 'circuitTypeID', 'subCircuitTypeID', 'currency', 'billingAccountID',
        'financeAccountTypeName', 'clientName', 'vendor', 'endUserID', 'userName', 'emailAddress', 'lineManager',
        'installDate', 'disconnectDate', 'suspensionDate', 'AddPlanDetails'
    ]
}

export const SET_USER_INFORMATION = 'SET_USER_INFORMATION';

export const REQUEST_STATUS_DATA_DISPLAY = [{ name: 'Approved', color: '#7ec344' },
{ name: 'Cancelled', color: '#d5002f' },
{ name: 'Rejected', color: '#d5002f' },
{ name: 'Waiting for Approval', color: "" },
{ name: 'Approved', color: '#00baff' },
{ name: 'In Progress', color: "" },
{ name: 'In Progress (Awaiting Submission to Vendor)', color: "" },
{ name: 'In Progress (Submitted to Vendor)', color: "" },
{ name: 'Completed', color: "" },
{ name: "", color: "" }
];

export const CATALOGUE_TABLE_HEADERS = [
    {
        name: "Vendor"
    },
    {
        name: "Account"
    }, {
        name: "Price Plan"
    }, {
        name: "Price Component"
    }, {
        name: "Description"
    }, {
        name: "Component Cost"
    }, {
        name: "Currency"
    }, {
        name: "Plan Status"
    }
]

export const ACCOUNT_TABLE_HEADERS = [
    {
        name: "Account Number"
    },
    {
        name: "Sub-Account"
    }, {
        name: " Account Type"
    }, {
        name: "Vendor"
    }, {
        name: "Status"
    }
]

export const EQUIPMENT_TYPE = {
    Device: 1,
    Accessory: 2
}

export const CIRCUIT_STATUS = {
    inService: {id: 1, name:'In Service'},
    outOfService: {id:2, name:'Out of Service'},
    suspended: {id:3, name:'Suspended'},
    pending: {id:4, name:'Pending'},
}

export const EXCLUDE_SELECT_CLIENT_FOR_ROLE_ID = {
    ClientVIP: 2,
    ClientReports: 13,
    ClientGuest: 16
}

export const REDIRECT_TO_EXTERNAL_FOR_ROLE_ID = {
    ClientUser: 4,
    ClientManager: 6
}
export const CONFIRMATION_VALUE = {
    Ok: "ok",
    Cancel: "cancel"
}
export const BUSINESS_CASE = {
    Other: "Other"
}
export const YES_OR_NO= {
    Yes: "Yes",
    No: "No"
}

export const DATE_FORMAT = {
    ISO:'YYYY-MM-DDTHH:mm:ss.SSSZ'
}

export const MOBILE_POLICY_URL = 'https://www.accenture.com/us-en/about/privacy-policy';

export const USER_GUIDE_URL = 'https://atemprdopsstorage.blob.core.windows.net/atem/Ross/ATEM%20User%20Guide%20-%20Ross.pdf?sp=r&st=2023-02-20T14:40:39Z&se=2023-12-30T22:40:39Z&spr=https&sv=2021-06-08&sr=b&sig=%2fQqUjXP%2Bi9iaBuaPCplHomnMUUFd9LA57DA7q55MOwo%3D';

export const STRING_VALUES = {
    stringNull: "null",
    stringZero: "0",
}
export const ERROR_SOURCE = {
    cost_allocation_user: "userCostAllocations"
}

export const DEFAULT_VALUE = {
     defaultValue: "default"
}

export const BANDWIDTH_UNIT = {
    GBPS: { id: 149, name: 'Gbps' },
    KBPS: { id: 148, name: 'Kbps' },
    MBPS: { id: 147, name: 'Mbps' },
    TBPS: { id: 150, name: 'Tbps' },
}